import React from "react";
import ReactDOM from "react-dom";
import Loadable from "react-loadable";
import { AsynLoader } from "../Loader/AsynLoader";

const ModalConductor = props => {
  document.querySelector("body").style.overflowY = "hidden";
  document.querySelector("html").style.overflowY = "hidden";

  document.querySelector("body").style.height = "100%";
  document.querySelector("html").style.height = "100%";

  switch (props.currentModal) {
    case "ASK_QUESTION":
      return ReactDOM.createPortal(
        <AsynAskQuestionModal {...props} />,
        document.getElementById("modal-root")
      );
    case "MEMBER_DETAILS":
      return ReactDOM.createPortal(
        <AsynMemberDetails {...props} />,
        document.getElementById("modal-root")
      );

    case "USER_DETAILS":
      return ReactDOM.createPortal(
        <AsynUserDetails {...props} />,
        document.getElementById("modal-root")
      );
    case "THANK_YOU":
      return ReactDOM.createPortal(
        <AsynCompleted {...props} />,
        document.getElementById("modal-root")
      );
    default:
      document.querySelector("body").style.overflowY = "auto";
      document.querySelector("html").style.overflowY = "auto";
      document.querySelector("body").style.height = "initial";
      document.querySelector("html").style.height = "initial";
      return null;
  }
};

export default ModalConductor;

const AsynAskQuestionModal = Loadable({
  loader: () => import("./components/AskQuestionModal"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader
});

const AsynMemberDetails = Loadable({
  loader: () => import("./components/MemberDetails"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader
});
const AsynUserDetails = Loadable({
  loader: () => import("./components/UserDetails"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader
});
const AsynCompleted = Loadable({
  loader: () => import("./components/Completed"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader
});
